import React, { forwardRef } from "react"
import { Box } from "@mui/material"
import { MagnifierWrapper } from "../Testing/ImageMagnifier"
import { useStyles } from "./styles"

type Props = {
  imageProps?: Record<"alt" | "data-description", string>
  loading?: boolean
  src?: string
  className?: string
  modalImageClassname?: string
  styles?: string
  onImageLoaded?: () => void
  onClick?: React.MouseEventHandler<HTMLDivElement>
}

const ChoiceImage = forwardRef<HTMLImageElement, Props>((props, ref) => {
  const {
    src,
    loading,
    imageProps,
    className,
    modalImageClassname,
    styles,
    onImageLoaded,
    onClick
  } = props

  const { classes } = useStyles()

  return (
    <Box
      className={classes.root}
      onClick={onClick}
      data-automation-id="choice-image-container"
    >
      <MagnifierWrapper
        ref={ref}
        src={src}
        blobLoading={loading}
        imageProps={imageProps}
        className={className}
        modalImageClassname={modalImageClassname ?? className}
        styles={styles}
        onImageLoaded={onImageLoaded}
        stopPropagation
      />
    </Box>
  )
})

export default ChoiceImage
